import { PhoneNumberSchema } from "@redotech/redo-model/phone/phone-number";
import * as z from "zod/v4";

export const getPhoneNumberForTeam = {
  name: "getPhoneNumberForTeam" as const,
  input: z.object({}),
  output: PhoneNumberSchema.nullable(),
};
